import { render } from "./marketingExpenses.vue?vue&type=template&id=ef3c74d0"
import script from "./marketingExpenses.vue?vue&type=script&lang=js"
export * from "./marketingExpenses.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__